<div class="products-view-container" dir="rtl">
  <!-- Toggle Switch -->
 
  <!-- Detailed View -->
  <div *ngIf="showDetailedView" class="products-grid detailed-view">
    <div  class="product-card-wrapper">
      <div class="product-card product-card-detailed">
        <!-- Header with Seller Info -->
        <div class="card-header">
          <div class="seller-info">
            <div class="seller-avatar">
              <img 
                [src]="(product?.owner?.avatar?.filename ? (isDemoMode ? '' : BASE_API) + product?.owner?.avatar?.filename : 'assets/img/default-avatar.png')"
                onerror="this.src='assets/img/default-avatar.png'"
                alt="صورة البائع"
                class="avatar-img"
              />
            </div>
            <div class="seller-details">
              <h3 class="seller-name">
                {{ (product?.owner?.firstName || '') + ' ' + (product?.owner?.lastName || '') + ' ' + (product?.owner?.thirdName || '') || 'إسم المزود' }}
              </h3>
              <div class="product-meta">
                <span class="product-date">
                  <i class="far fa-calendar-alt"></i>
                  {{ product?.createdAt | date: 'EEEE، d MMMM y' : '+0300' : 'ar-SA' }}
                </span>
                <span *ngIf="product.isPublished == false" class="product-status sold">
                  <i class="fas fa-tag"></i> منتج مباع
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Product Image -->
        <div class="product-image-container" (click)="goToProduct(product)">
          <img
            [src]="(isDemoMode ? '' : BASE_API) + product?.images[0]?.filename"
            onerror="this.src='assets/img/mocks/stw.jpg'"
            alt="صورة المنتج"
            class="product-image"
          />
        </div>

        <!-- Product Details -->
        <div class="product-details">
          <h2 class="product-title" (click)="goToProduct(product)">{{ product?.name }}</h2>
          
          <div class="product-specs">
            <div class="spec-item">
              <i class="fas fa-tag"></i>
              <span>النوعية: <strong>{{ product?.type?.key }}</strong></span>
            </div>
            <div class="spec-item">
              <i class="fas fa-box-open"></i>
              <span>الكمية المتاحة: <strong>{{ product?.currentQuantity }} {{ product?.unit?.key }}</strong></span>
            </div>
          </div>

          <!-- Price Section -->
          <div class="product-price">
            <div class="price-main">
              <span class="price-amount">{{ product?.unitPrice }}</span>
              <span class="icon-saudi_riyal">&#xea;</span>
              <span class="price-unit">/ {{ product?.unit?.key }}</span>
              <span *ngIf="product?.hasActiveDiscount" class="badge badge-success mr-2" style="font-size: 0.7em;">
                خصم {{ product?.discountPercentage }}%
              </span>
            </div>
            <div *ngIf="product?.hasActiveDiscount" class="price-discounted" style="font-size: 0.85em; color: #28a745;">
              الإجمالي مع الرسوم: {{ product?.totalUnitPrice | number : '1.2-2' }}
              <span class="icon-saudi_riyal">&#xea;</span>
              / {{ product?.unit?.key }}
            </div>
            <div class="tax-info">
              {{ product.taxId ? 'شامل الضريبة' : 'غير شامل الضريبة' }}
            </div>
          </div>

          <!-- Action Button -->
          <button class="buy-button" (click)="goToProduct(product); $event.stopPropagation()">
            <i class="fas fa-shopping-cart"></i> شراء المنتج
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Compact View -->
  <div *ngIf="!showDetailedView" class="products-grid compact-view">
    <div  class="product-card-wrapper">
      <div class="product-card product-card-compact">
        <!-- Product Image -->
        <div class="product-image-container" (click)="goToProduct(product)">
          <img
            [src]="(isDemoMode ? '' : BASE_API) + product?.images[0]?.filename"
            onerror="this.src='assets/img/mocks/stw.jpg'"
            alt="صورة المنتج"
            class="product-image"
          />
          <div class="product-date-overlay">
            <i class="far fa-calendar-alt"></i>
            {{ product?.createdAt | date: 'EEEE، d MMMM y' : '+0300' : 'ar-SA' }}
          </div>
        </div>

        <!-- Product Details -->
        <div class="product-details">
          <h3 class="product-title" (click)="goToProduct(product)">{{ product?.name }}</h3>
          <p class="product-description">{{ product?.details }}</p>
          
          <div class="product-footer">
            <div class="product-specs">
              <div class="spec-item">
                <i class="fas fa-tag"></i>
                <span>{{ product?.type?.key }}</span>
              </div>
              <div class="spec-item">
                <i class="fas fa-box-open"></i>
                <span>{{ product?.currentQuantity }} {{ product?.unit?.key }}</span>
              </div>
            </div>
            
            <div class="product-price">
              <span class="price-amount">{{ product?.unitPrice }}</span>
              <span class="icon-saudi_riyal">&#xea;</span>
              <span *ngIf="product?.hasActiveDiscount" class="badge badge-success" style="font-size: 0.65em; margin-right: 4px;">
                خصم {{ product?.discountPercentage }}%
              </span>
              <div *ngIf="product?.hasActiveDiscount" style="font-size: 0.75em; color: #28a745;">
                {{ product?.totalUnitPrice | number : '1.2-2' }} <span class="icon-saudi_riyal">&#xea;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>